import React from 'react';
import { createPortal } from 'react-dom';
import { logout } from '../../api/auth';
import { Environments } from '../../controllers/Environments';
import { classes } from '../../utils/commonUtils';
import css from './current-env.module.scss';

const environments = Environments();

export function CurrentEnv() {
  return createPortal(<CurrentEnvContainer />, document.body);
}

const envs = ['at', 'production'];

function CurrentEnvContainer() {
  const env = environments.getAppEnv();

  return (
    <div className={css.container}>
      <span className={classes(css.btn, css.main)}>{env.slice(0, 4).toUpperCase()}</span>
      <div className={css.buttonContainer}>
        {envs
          .filter((e) => e !== env)
          .map((e) => (
            <button
              key={e}
              className={css.btn}
              onClick={() => {
                logout();
                window[e.slice(0, 4)]?.();
                // eslint-disable-next-line @typescript-eslint/dot-notation
                window['callMeBack']?.();
              }}
            >
              {e.slice(0, 4).toUpperCase()}
            </button>
          ))}
      </div>
    </div>
  );
}
